/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
import"../../core/has.js";import r from"../../core/Logger.js";import"../../core/Error.js";r.getLogger("esri/views/webgl");function o(r){}export{o as checkWebGLError};
